<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="calendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">Add</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>Today</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Add Event"
        accept-text= "Add Event"
        @accept="addEvent"
        :is-valid="validForm"
        :active.sync="activePromptAddEvent">
        <div class="my-4">
          <p>Event Type</p>
          <div class="vx-row">
            <div class="vx-col sm:w-4/5 w-full">
              <div class="horizontal-row">
                <vs-button
                  v-for="(venueTrainingType) in venueTrainingTypes"
                  :key="venueTrainingType.id"
                  @click="selectedVenueTrainingType = venueTrainingType.id"
                  :color="selectedVenueTrainingType == venueTrainingType.id ? 'success' : 'rgb(80, 80, 80)'"
                  :type="selectedVenueTrainingType == venueTrainingType.id ? 'filled' : 'border'"
                  icon-pack="feather"
                  :icon="selectedVenueTrainingType == venueTrainingType.id ? 'icon-check' : ''"
                  class="mr-3 selection-button"
                >{{venueTrainingType.label}}</vs-button>
              </div>
            </div>
          </div>
        </div>

        <div class="my-4">
            <small class="date-label">Title</small>
            <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="Title" v-model="title"></vs-input>
        </div>
        <div class="my-4">
            <small class="date-label">Description</small>
            <textarea class="vs-inputx vs-input--input normal" style="height:120px;font-family: Arial;line-height: 1.5rem;" spellcheck="false" v-model="description" placeholder="Description..." />
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-2/5 w-full" style="display: flex;">
            <div>
                <small class="date-label">Start Date</small>
                <flat-pickr :config="configdateStartTimePicker" v-model="startDate" placeholder="Start..." style="display: flex;" />
            </div>

            <div style="margin-left: 8px;">
                <small class="date-label">End Date</small>
                <flat-pickr :config="configdateEndTimePicker" v-model="endDate" placeholder="End..." style="display: flex;" />
            </div>
          </div>
        </div>

        <div class="my-4">
          <p>Select Instructor</p>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-4/5 w-full">
              <TypeAhead
                  v-model="data"
                  classes="typeahead-container"
                  :placeholder="placeholder"
                  src=""
                  :getResponse="getResponse"
                  :selectFirst="selectFirst"
                  :limit="parseInt(limit)"
                  :queryParamName="queryParamName"
                  :minChars="parseInt(minChars)"
                  :delayTime="parseInt(delayTime)"
                  :onHit="onHit"
                  :highlighting="highlighting"
                  :render="render"
                  :fetch="fetch"
                ></TypeAhead>

                <vs-chip v-if="instructorId !== null" color="success" class="mt-6 instructor-chip">
                  {{instructorDisplayName}}
                </vs-chip>
            </div>
          </div>
        </div>

        <div class="my-4" style="display: inline-block;">
            <small class="date-label">Min Participants</small>

            <vs-input v-validate="'numeric'" name="minParticipants" v-model="minParticipants" placeholder="Min participants..." />
            <div class="text-danger text-sm" v-show="errors.has('minParticipants')">{{ errors.first('minParticipants') }}</div>
        </div>

        <div class="my-4 ml-6" style="display: inline-block;">
            <small class="date-label">Max Participants</small>
            
            <vs-input v-validate="'numeric'" name="maxParticipants" v-model="maxParticipants" placeholder="Max participants..." />
            <div class="text-danger text-sm" v-show="errors.has('maxParticipants')">{{ errors.first('maxParticipants') }}</div>
        </div>

        <div class="my-4">
          <p>Tags (optional)</p>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-4/5 w-full">
              <vs-chips placeholder="New Tag" v-model="tags" style="width: 100%">
                <vs-chip
                  color="#24c1a0"
                  :key="tag"
                  @click="removeTag(tag)"
                  v-for="tag in tags" closable>
                  {{ tag }}
                </vs-chip>
              </vs-chips>
            </div>
          </div>
        </div>
    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Edit Event"
        accept-text= "Submit"
        cancel-text = "Remove"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent"
        :is-valid="validForm"
        :active.sync="activePromptEditEvent">

        <div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">

                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>

                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

        </div>

        <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="Event Title" v-model="title"></vs-input>
        <div class="my-4">
            <small class="date-label">Start Date</small>
            <datepicker :config="configdateStartTimePicker" v-model="startDate" placeholder="Start..."></datepicker>
        </div>
        <div class="my-4">
            <small class="date-label">End Date</small>
            <datepicker :config="configdateEndTimePicker" v-model="endDate" placeholder="End..."></datepicker>
        </div>
        <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>

    </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
// import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require('vue-simple-calendar/static/css/default.css')

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import TypeAhead from 'vue2-typeahead'

import Datepicker from 'vuejs-datepicker'
import { en } from 'vuejs-datepicker/src/locale'

export default {
  components: {
    flatPickr,
    TypeAhead,
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data () {
    let ctx = this;

    return {
      configdateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        minDate: new Date(),
        dateFormat: 'd-m-Y H:i',
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function(selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateStartDate(selectedDates[0]);
        }
      },
      configdateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        minDate: new Date(),
        dateFormat: 'd-m-Y H:i',
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function(selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateEndDate(selectedDates[0]);
        }
      },

      // Typeahead
      data: '',
      selectFirst: false,
      limit: 10,
      queryParamName: ':keyword',
      minChars: 2,
      delayTime: 500,
      placeholder: 'Please enter Instructor name or email',
      classes: 'typeahead',

      events: [],
      
      showDate: new Date(),
      disabledFrom: false,
      overrideStartHours: false,
      overrideEndHours: false,
      id: 0,
      title: '',
      description: '',
      startDate: null,
      localStartDate: null,
      endDate: null,
      localEndDate: null,
      minParticipants: 1,
      maxParticipants: 10,
      tags: [],
      instructorId: null,
      instructorDisplayName: null,

      selectedVenueTrainingType: 0,
      venueTrainingTypes: [
        {
          id: 0,
          label: "Regular Event"
        },
        {
          id: 1,
          label: "Masterclass"
        }
      ],

      labelLocal: 'none',

      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: 'Month',
          val: 'month'
        },
        {
          label: 'Week',
          val: 'week'
        },
        {
          label: 'Year',
          val: 'year'
        }
      ]
    }
  },
  computed: {
    calendarEvents () {
      return this.transformEvents();
    },
    validForm () {
      return this.title !== '' && this.description !== '' && this.localStartDate !== null && this.localEndDate !== null && this.instructorId !== null && !this.errors.has('event-url')
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return [
            {
            text: 'Regular Event',
            value : 'venueTraining',
            color: 'success'
            },
            {
            text: 'Masterclass',
            value: 'masterclass',
            color: 'warning'
            }
        ];
      //return this.$store.state.calendar.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'business') return 'success'
        else if (label === 'work')     return 'warning'
        else if (label === 'personal') return 'danger'
        else if (label === 'none')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    removeTag (item) {
      this.tags.splice(this.tags.indexOf(item), 1)
    },

    updateStartDate: function(date) {
      this.localStartDate = date;

      this.constrainDates();
    },
    updateEndDate: function(date) {
      console.log("Update End Date:", date);
      this.localEndDate = date;

      console.log(this.localEndDate);

      this.constrainDates();
    },
    constrainDates: function () {
      if (this.localStartDate !== null && this.localEndDate === null) {
        this.localEndDate = new Date(this.localStartDate);
        this.localEndDate.setHours(20);

        this.endDate = new Date(this.localEndDate);
      }

      if (this.localEndDate < this.localStartDate) {
        this.localEndDate = new Date(this.localStartDate);
        this.endDate = new Date(this.localEndDate);
      }
    },

    getResponse: function (response) {
      return response.data
    },
    onHit: function (item, vue/*, index*/) {
      let current = vue.current
      let selectedItem = vue.data[current]

      this.instructorId = selectedItem.userId;
      this.instructorDisplayName = item;

      vue.query = selectedItem.firstName + ' ' + selectedItem.lastName;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`)
    },
    render: function (items/*, vue*/) {
      const titles = items.map(x => x.firstName + ' ' + x.lastName + ' (' + x.email + ')');
      return titles
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API +'/users?query=' + this.data)
    },


    transformEvents: function() {
      return this.events.map(x => this.transformEvent(x));
    },
    transformEvent: function(apiEvent) {
      return {
        id: apiEvent.calendarEventId,
        title: apiEvent.title,
        startDate: new Date(apiEvent.startDateUtcTicks),
        endDate: new Date(apiEvent.endDateUtcTicks),
        url: apiEvent.url,
        classes: 'event-success',
        label: apiEvent.label
      };
    },
    getCalendarEvents: function() {
      this.$vs.loading();

      this.$http.get(process.env.VUE_APP_API +'/calendar?query=*')
        .then(resp => {
          console.log(resp.data);
          
          this.events = resp.data;
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch events: ' + err
            });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    addEvent () {
      this.$vs.loading()

      const payload = {
        title: this.title,
        description: this.description,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        minParticipants: parseInt(this.minParticipants),
        maxParticipants: parseInt(this.maxParticipants),
        tags: this.tags,
        instructorId: this.instructorId,
        instructorDisplayName: this.instructorDisplayName,
        venueTrainingType: this.selectedVenueTrainingType
      };

      this.$http.post(process.env.VUE_APP_API +'/VenueTrainings', payload)
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Event added'
            });

            this.getCalendarEvents();
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not add Event: ' + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        });

      //const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      //obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      //this.$store.dispatch('calendar/addEvent', obj)
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'none'
    },
    promptAddNewEvent (date) {
      console.log("promptAddNewEvent");
      this.disabledFrom = false
      this.overrideStartHours = true
      this.overrideEndHours = true
      this.addNewEventDialog(date)
    },
    addNewEventDialog (date) {
      console.log("addNewEventDialog");
      console.log(date);
      
      this.clearFields()

      this.startDate = new Date(date);
      this.startDate.setHours(18);
      this.startDate.setMinutes(0);
      this.startDate.setSeconds(0);

      this.updateStartDate(this.startDate);

      this.activePromptAddEvent = true
    },
    openAddNewEvent (date) {
      console.log("openAddNewEvent");
      this.disabledFrom = true
      this.addNewEventDialog(date)
    },
    openEditEvent (event) {
        console.log("TODO: openEditEvent");
        console.log(event);

        this.$router.push({ name: 'admin-venue-training', params: { venueTrainingId: event.id } }).catch(() => {})
      /*
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true
      */
    },
    editEvent () {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      //this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent () {
      //this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged (/*event, date*/) {
      //this.$store.dispatch('calendar/eventDragged', {event, date})
    }
  },
  created () {
    this.getCalendarEvents();
    /*
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch('calendar/fetchEvents')
    this.$store.dispatch('calendar/fetchEventLabels')
    */
  },
  beforeDestroy () {
    //this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";

.horizontal-row {
  display: flex;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}

.typeahead-container input {
  padding: .7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: .4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.15);
  box-shadow: 0 0 0 0 rgba(0,0,0,.15);
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
</style>
